import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=5c3f5fee"
import script from "./UiCard.vue?vue&type=script&lang=js"
export * from "./UiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports